// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pe-0";
export var leftAlign = "_pe-4";
export var listItem = "_pe-2";
export var listItemWrapper = "_pe-1";
export var operationText = "_pe-3";